export const COUPON_VERIFY_REQUEST = 'COUPON_VERIFY_REQUEST';
export const COUPON_VERIFY_SUCCESS = 'COUPON_VERIFY_SUCCESS';
export const COUPON_VERIFY_FAIL = 'COUPON_VERIFY_FAIL';
export const COUPON_REDEEM_REQUEST = 'COUPON_REDEEM_REQUEST';
export const COUPON_REDEEM_SUCCESS = 'COUPON_REDEEM_SUCCESS';
export const COUPON_REDEEM_FAIL = 'COUPON_REDEEM_FAIL';
export const COUPON_WELCOME_REQUEST = 'COUPON_WELCOME_REQUEST';
export const COUPON_WELCOME_SUCCESS = 'COUPON_WELCOME_SUCCESS';
export const COUPON_WELCOME_FAIL = 'COUPON_WELCOME_FAIL';
export const COUPON_LIST_REQUEST = 'COUPON_LIST_REQUEST';
export const COUPON_LIST_SUCCESS = 'COUPON_LIST_SUCCESS';
export const COUPON_LIST_FAIL = 'COUPON_LIST_FAIL';
export const COUPON_SAVE_REQUEST = 'COUPON_SAVE_REQUEST';
export const COUPON_SAVE_SUCCESS = 'COUPON_SAVE_SUCCESS';
export const COUPON_SAVE_FAIL = 'COUPON_SAVE_FAIL';
export const COUPON_DELETE_REQUEST = 'COUPON_DELETE_REQUEST';
export const COUPON_DELETE_SUCCESS = 'COUPON_DELETE_SUCCESS';
export const COUPON_DELETE_FAIL = 'COUPON_DELETE_FAIL';
export const COUPON_EMAIL_REQUEST = 'COUPON_EMAIL_REQUEST';
export const COUPON_EMAIL_SUCCESS = 'COUPON_EMAIL_SUCCESS';
export const COUPON_EMAIL_FAIL = 'COUPON_EMAIL_FAIL';